const translations = {
    circle: 'Circle',
    polygon: 'Polygon'
};

export default translations;
